// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.feedclaims.RentalManagerUserFeedClaimsWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserFeedClaimsWebApiHandler_request } from '@zg-rentals/ts-rental-manager-api-beta-client';

import type { RentalManagerUserFeedClaimRequestType } from '@zg-rentals/ts-rental-manager-api-beta-client';

interface RequestParams {
  companyName?: string;
  email?: string;
  feedOrCompanyId?: string;
  feedProviderName?: string;
  fullAddress?: string;
  note?: string;
  requestType: RentalManagerUserFeedClaimRequestType;
  unitNumber?: string;
}

export interface RentalManagerUserFeedClaimsWebApiHandler_request_Args {
  getParams: RequestParams;
}

export type RentalManagerUserFeedClaimsWebApiHandler_request_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserFeedClaimsWebApiHandler_request_Args
>;

/**
 * Create a claim feed listing request
 */
export const useRentalManagerUserFeedClaimsWebApiHandler_request = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserFeedClaimsWebApiHandler_request_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserFeedClaimsWebApiHandler_request_Args) =>
      RentalManagerUserFeedClaimsWebApiHandler_request(args.getParams, httpClient),
  });
};
